import { MAX_WIDTH } from 'constants/maxWidth'
import React, { useMemo } from 'react'
import { ImageProps, Image as RNImage } from 'react-native'

import { getTransformedMedia } from 'utils/files/fileTransformations'

type Props = ImageProps & {
  source: { uri?: string }
  imageWidth?: number
}

export const Image = ({ source, imageWidth = MAX_WIDTH, ...rest }: Props) => {
  const transformedSource = useMemo(
    () => (source.uri ? { uri: getTransformedMedia('image', source.uri, imageWidth * 2) } : source),
    [imageWidth, source],
  )

  return <RNImage {...rest} source={transformedSource} />
}
